import Filter from "./Filter";
import ListData from "./ListData";
import TableData from "./TableData";
import ConfirmRestoreModal from "./ConfirmRestore";

const vaultHistoryComponents = {
  Filter,
  ListData,
  TableData,
  ConfirmRestoreModal
}

export default vaultHistoryComponents